import { useState } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const AnnotationsSidebar = ({
  pins,
  onSelect,
  onDelete,
  onSave,
  handleCheckboxChange,
}) => {
  const [editIndex, setEditIndex] = useState(null);
  const [editedText, setEditedText] = useState("");
  const [allVisible, setAllVisible] = useState(false);

  const toggleAllModelsVisibility = () => {
    setAllVisible(!allVisible);
    pins.forEach((pin) => {
      handleCheckboxChange(!allVisible, pin.id);
    });
  };

  return (
    <div
      className="absolute right-0 top-12 w-80 bg-slate-50/95 backdrop-blur-xl border-l border-slate-200/60 shadow-2xl z-20 h-[calc(100%-3rem)] flex flex-col transition-all duration-300"
      style={{
        "--main-color": anatomyConstants.mainColor,
        "--main-color-bold": anatomyConstants.mainColorBold,
      }}
    >
      <div className="bg-gradient-to-r from-[var(--main-color)] to-[var(--main-color-bold)] text-white p-3 flex items-center justify-between shadow-md flex-shrink-0 z-10">
        <button
          onClick={toggleAllModelsVisibility}
          className="px-3 py-1.5 rounded-md bg-white/10 hover:bg-white/20 active:bg-white/30 transition-all duration-200 text-xs font-bold tracking-wide backdrop-blur-sm border border-white/10"
        >
          {allVisible ? "Hide All" : "Show All"}
        </button>
        <span className="flex-grow text-right text-sm font-bold tracking-wider opacity-90 pr-2">ANNOTATIONS</span>
      </div>

      <div className="flex-1 overflow-y-auto">
        <ul className="list-none m-0 p-0 pb-4">
        {pins.map((pin, index) => (
          <li
            key={index}
            onClick={() => onSelect(pin)}
            className="cursor-pointer p-4 hover:bg-gray-100 bg-white border-b-2 border-gray-300 transition-colors duration-150 ease-in-out flex justify-between items-center"
          >
            <div className="flex items-center justify-start w-full">
              {editIndex === index ? (
                <input
                  type="text"
                  value={editedText}
                  onChange={(e) => setEditedText(e.target.value)}
                  className="w-full border border-gray-300 rounded px-2 py-1 text-gray-800 focus:outline-none focus:ring focus:border-blue-500"
                  onClick={(e) => e.stopPropagation()}
                />
              ) : (
                <div>
                  <div className="font-medium md:font-normal md:text-sm text-gray-800">
                    {pin.annotation}
                  </div>
                  <div className="text-xs md:font-light text-gray-600 truncate">
                    Annotation {index + 1}
                  </div>
                </div>
              )}
            </div>
            <div className="flex items-center">
              <label
                className="inline-flex items-center cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <input
                  type="checkbox"
                  value={pin.show ? "true" : "false"}
                  className="sr-only peer"
                  checked={pin.show}
                  onChange={(e) => {
                    handleCheckboxChange(e.target.checked, pin.id);
                  }}
                />
                <div className="relative w-7 h-4 md:w-5 md:h-3 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full md:after:h-2 md:after:w-2 after:h-3 after:w-3 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (editIndex === index) {
                    onSave(editedText, pin.id);
                    setEditIndex(null);
                  } else {
                    setEditIndex(index);
                    setEditedText(pin.annotation);
                  }
                }}
                className="px-2 py-1 md:p-0 bg-[var(--main-color)] text-white font-semibold md:font-normal text-xs rounded hover:bg-[var(--main-color-bold)] transition-colors duration-150 ease-in-out ml-2 md:h-8 md:w-8"
              >
                {editIndex === index ? <SaveIcon /> : <EditIcon />}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  if (editIndex === index) {
                    setEditIndex(null);
                  } else {
                    onDelete(index, pin.id);
                  }
                }}
                className={`px-2 py-1 md:p-0 ${
                  editIndex === index
                    ? "bg-gray-500 hover:bg-gray-600"
                    : "bg-red-500 hover:bg-red-600"
                } text-white font-semibold md:font-normal text-xs rounded transition-colors duration-150 ease-in-out ml-2 md:h-8 md:w-8`}
              >
                {editIndex === index ? <CloseIcon /> : <DeleteOutlineIcon />}
              </button>
            </div>
          </li>
        ))}
        </ul>
      </div>
      {/* Footer buffer zone */}
      <div className="bg-slate-50 border-t border-slate-200 text-center p-3 flex-shrink-0 z-10">
        <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider">
          Powered by Wellztech
        </p>
      </div>
    </div>
  );
};

export default AnnotationsSidebar;
